export function toMin(s) {
  const [h, m] = s.split(":").map(Number);
  return h * 60 + m;
}

export function toHHMM(m) {
  return `${String(Math.floor(m / 60)).padStart(2, "0")}:${String(m % 60).padStart(2, "0")}`;
}

export function fmtTime(hhmm) {
  const [h, m] = hhmm.split(":").map(Number);
  const ap = h >= 12 ? "PM" : "AM";
  const hh = ((h + 11) % 12) + 1;
  return `${hh}:${String(m).padStart(2, "0")} ${ap}`;
}

export function generateSlots(open, close, interval, duration, intervals) {
  const o = toMin(open);
  const c = toMin(close);
  const slots = [];
  for (let s = o; s + duration <= c; s += interval) {
    const e = s + duration;
    const conflict = intervals.some(([bs, be]) => s < be && bs < e);
    slots.push({ start: toHHMM(s), startMin: s, available: !conflict });
  }
  return slots;
}

export function fmtDate(dateStr) {
  const d = new Date(dateStr + "T00:00:00");
  return d.toLocaleDateString("en-IN", { weekday: "short", day: "numeric", month: "long", year: "numeric" });
}

export function toDateStr(d) {
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
}
